import { parseSmartPaste } from '@/api/smartPasteService';
import { useSentryMutation } from '../utils/sentryQueryWrapper';
import type { SmartPasteResponse } from '@/types/smartPaste';

/**
 * POST /v1/merchants/orders/smart-paste — parse free-form text into a
 * create-order preview. Read-only: it never creates an order, so there is
 * nothing to invalidate on success.
 */
export const useSmartPasteParse = () =>
  useSentryMutation<SmartPasteResponse, Error, string>((text: string) => parseSmartPaste(text));
